import { getAlbumPath } from '../../utils/getPublicPath';
import { tags } from '../tags';
import type { Playlist, Song } from '../../interfaces/types';

export enum JobTypesEnum { JOB = 'JOB' }
const publicURL = (url: string) => process.env.PUBLIC_URL + url;

/* ----- Wipro ----- */
const Wipro: Song = {
  name: 'WIPRO_SCHOLAR_TRAINEE',
  length: 'Sep 2025 – Present',
  artist: 'Wipro',
  types: [JobTypesEnum.JOB],
  imageUrl: publicURL('/images/experience/wipro.png'),
  experience: `Working as a Scholar Trainee (Software Developer) at Wipro since September 2025.

Contributing to software development tasks as part of the team, gaining hands-on experience with enterprise-scale development practices, collaborative workflows, and production-grade engineering standards.`,
  skills: [tags.Java, tags.SpringBoot, tags.React, tags.JavaScript],
};

/* ----- HPE ----- */
const HPE: Song = {
  name: 'HPE_JOB_SIMULATION',
  length: '2025',
  artist: 'Hewlett Packard Enterprise',
  types: [JobTypesEnum.JOB],
  link: 'https://drive.google.com/file/d/1wTa8dnXiQmcUPZ3GGz6HLfu5MwkldhP4/view',
  imageUrl: publicURL('/images/experience/hpe.png'),
  experience: `Over the period of January 2025, completed practical tasks in the Software Engineering job simulation at Hewlett Packard Enterprise.

Tasks included:
- Creating a proposal for a RESTful Web Service
- Building a basic RESTful Web Service
- Implementing the ability to upload data
- Creating unit tests to ensure functionality and reliability

The simulation focused on REST API design, backend logic, and test-driven development practices.`,
  skills: [tags.React, tags['Node.js'], tags.TypeScript, tags.GitHub, tags.Postman],
};


/* ----- Deloitte ----- */
const Deloitte: Song = {
  name: 'DELOITTE_JOB_SIMULATION',
  length: '2025',
  artist: 'Deloitte Australia',
  types: [JobTypesEnum.JOB],
  link: 'https://drive.google.com/file/d/1pQUA_l4kCC2djzysF9uoAVKPIw-A2kN8/view',
  imageUrl: publicURL('/images/experience/deloitte.jpg'),
  experience: `Over the period of January 2025, completed practical tasks in the Technology Job Simulation at Deloitte Australia.

Tasks included:
- Coding
- Data Analysis
- Development
- Cyber Security
- Forensic Technology

The simulation provided experience in enterprise-level technical consulting, data-driven solutions, and cybersecurity practices.`,
  skills: [tags.React, tags['Node.js'], tags.AWS, tags.GitHub],
};

/* ----- Mastercard ----- */
const Mastercard: Song = {
  name: 'MASTERCARD_JOB_SIMULATION',
  length: '2025',
  artist: 'Mastercard',
  types: [JobTypesEnum.JOB],
  link: 'https://drive.google.com/file/d/1LZDUi0h5XNnBpFqF2vVpn3lLc-pCa2_U/view',
  imageUrl: publicURL('/images/experience/mastercard.png'),
  experience: `Over the period of January 2025, completed practical tasks in the Cybersecurity Job Simulation at Mastercard.

Tasks included:
- Designing a phishing email simulation
- Interpreting phishing simulation results

The simulation focused on threat analysis, security awareness, and identifying vulnerabilities through simulated attack scenarios.`,
  skills: [tags.Python, tags.Linux, tags.Git, tags.Postman],
};

/* ----- Electronic Arts ----- */
const EA: Song = {
  name: 'EA_JOB_SIMULATION',
  length: '2025',
  artist: 'Electronic Arts (EA)',
  types: [JobTypesEnum.JOB],
  link: 'https://drive.google.com/file/d/17Xu3ArRLglgsP_X4jOZfnWKuW02oVUxT/view',
  imageUrl: publicURL('/images/experience/ea.png'),
  experience: `Over the period of January 2025, completed practical tasks in the Software Engineering Job Simulation at Electronic Arts (EA).

Tasks included:
- Writing a feature proposal
- Creating a game object class
- Improving the inventory system
- Performing a live bug fix

This simulation provided experience in gameplay systems, object-oriented programming, debugging, and collaborative software development within a game engineering environment.`,
  skills: [tags.React, tags.JavaScript, tags.GitHub, tags['CI/CD']],
};

export const ProfessionalExperience: Playlist = {
  name: 'EXPERIENCE',
  color: '#422023',
  filters: [JobTypesEnum.JOB],
  songs: [Wipro, HPE, Deloitte, Mastercard, EA],
  getImage(lang) {
    return getAlbumPath('Experience-cover', lang, 'png');
  },
};
